import { IonIcon } from '@ionic/react'
import { useStore, useStoreMap } from 'effector-react'
import { alertCircleSharp } from 'ionicons/icons'
import * as mainBalance from '~/entities/MainBalance/model'
import { CURRENCY } from '~/shared/config/constants'
import { notificationModalOpen } from '~/shared/lib/notificationModal'
import { parseSumForUi } from '~/shared/lib/utils'
import { DrawerComponent, useDrawer } from '~/shared/ui/Drawer'
import { Skeleton } from '~/shared/ui/SkeletonList'
import { myPalette } from '~/shared/ui/theme'
import {
  BalanceItem,
  Chip,
  DrawerTitle,
  ItemAmount,
  ItemIcon,
  ItemLabel,
  ItemLeft,
  StaticBalanceItem,
} from './styled'

const SHOWN_TYPES = ['BY_BONUS', 'BY_DEPT'] as const

const BALANCE_CONFIG: Record<
  string,
  { label: string; icon: string; route: string }
> = {
  BY_BONUS: {
    label: 'Бонусный',
    icon: '/images/icon-wallet.svg',
    route: '/balance-bonus',
  },
  BY_DEPT: {
    label: 'Задолженность',
    icon: '/images/icon-debts-circle.svg',
    route: '/balance-debt',
  },
}

export function BalanceDropdown() {
  const [isOpen, open, close] = useDrawer()

  const customerMeError = useStore(mainBalance.$customerMeError)
  const isCustomerMePending = useStore(mainBalance.getCustomerMeFx.pending)
  const isMainLoading = useStore(mainBalance.getCurrentBalanceFx.pending)
  const isAllLoading = useStore(mainBalance.getAllBalancesFx.pending)

  const mainAmount = useStoreMap(
    mainBalance.$currentBalance,
    (b) => b?.getAmount() ?? 0,
  )

  const additionalBalances = useStore(mainBalance.$allBalances).filter((b) =>
    SHOWN_TYPES.includes(b.getBalanceType() as (typeof SHOWN_TYPES)[number]),
  )

  const handleMainBalanceErrorClick = () => {
    notificationModalOpen({
      title: 'Ошибка!',
      description: customerMeError || '',
      variant: 'error' as const,
    })
  }

  const isMainBalanceLoading = isCustomerMePending || isMainLoading

  return (
    <>
      <Chip onClick={open}>Баланс</Chip>

      <DrawerComponent isShow={isOpen} onCancel={close}>
        <DrawerTitle>Балансы</DrawerTitle>

        {isMainBalanceLoading ? (
          <Skeleton
            animated
            $height={68}
            style={{ borderRadius: 12, marginBottom: 8 }}
          />
        ) : customerMeError ? (
          <StaticBalanceItem
            onClick={handleMainBalanceErrorClick}
            style={{ cursor: 'pointer' }}
          >
            <ItemLeft>
              <ItemIcon src='/images/icon-wallet.svg' alt='' />
              <ItemLabel>Основной баланс</ItemLabel>
            </ItemLeft>
            <IonIcon
              icon={alertCircleSharp}
              style={{ color: myPalette.coral.main, fontSize: 24 }}
            />
          </StaticBalanceItem>
        ) : (
          <BalanceItem to='/balance' onClick={close}>
            <ItemLeft>
              <ItemIcon src='/images/icon-wallet.svg' alt='' />
              <ItemLabel>Основной баланс</ItemLabel>
            </ItemLeft>
            <ItemAmount>
              <strong>{parseSumForUi(mainAmount)}</strong> {CURRENCY}
            </ItemAmount>
          </BalanceItem>
        )}

        {isAllLoading
          ? SHOWN_TYPES.map((type) => (
              <Skeleton
                key={type}
                animated
                $height={68}
                style={{ borderRadius: 12, marginBottom: 8 }}
              />
            ))
          : additionalBalances.map((balance) => {
              const type = balance.getBalanceType() ?? ''
              const config = BALANCE_CONFIG[type]
              if (!config) return null
              return (
                <BalanceItem
                  key={balance.getApiId()}
                  to={config.route}
                  onClick={close}
                >
                  <ItemLeft>
                    <ItemIcon src={config.icon} alt='' />
                    <ItemLabel>{config.label}</ItemLabel>
                  </ItemLeft>
                  <ItemAmount>
                    <strong>{parseSumForUi(balance.getAmount())}</strong>{' '}
                    {CURRENCY}
                  </ItemAmount>
                </BalanceItem>
              )
            })}
      </DrawerComponent>
    </>
  )
}
